<template>
  <MessageItem
    :date="message.createdAt"
    :userType="userType"
    :personalityType="personalityType"
    :isReadByUser="isReadByUser"
    @clickUserThumbnail="$emit('clickUserThumbnail')"
  >
    <p :class="$style.body">{{ message.body }}</p>
  </MessageItem>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import MessageItem from '@/components/molecules/MessageItem.vue'
import type { Message } from '@/types/app/message'
import type { ChatMessageUserType } from './ChatMessageUserType'
import type { PersonalityType } from '@/types/app'

export default defineComponent({
  name: 'ChatMessage',
  components: {
    MessageItem,
  },
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
    userType: {
      type: String as PropType<ChatMessageUserType>,
      required: true,
    },
    personalityType: {
      type: String as PropType<PersonalityType>,
      default: 'A',
    },
    isReadByUser: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" module>
.body {
  padding: 24px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;

  a {
    color: currentcolor;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
